export const MIN_LENGTH = 12; // spec §13; the API enforces it too

/** Client-side check only to save a round trip; the API is the authority. Names the field the message belongs under. */
export function checkNewPasswordFields(p: string, confirm: string): { field: "newPassword" | "newPasswordConfirm"; message: string } | null {
  if ([...p].length < MIN_LENGTH) return { field: "newPassword", message: `Yeni parola en az ${MIN_LENGTH} karakter olmalı.` };
  if (p !== confirm) return { field: "newPasswordConfirm", message: "Parolalar aynı olmalı." };
  return null;
}

export const checkNewPassword = (p: string, confirm: string): string | null => checkNewPasswordFields(p, confirm)?.message ?? null;
